import { ValidateProperty } from "../../../models/utilities/validate-property";

export class DriverCreate {

    public employeeId : string = '';
    
    @ValidateProperty({ required: true })
    public serviceCenterId : string = '';
    
    public samsaraId : string = '';
    
    @ValidateProperty({ required: true })
    public firstName : string = '';

    public middleName : string = '';
    
    @ValidateProperty({ required: true })
    public lastName : string = '';
    
    @ValidateProperty({ required: true })
    public cellPhone : string = '';

    public alternatePhone : string = '';

    public passportId : string = '';

    public driversLicenseNumber : string = '';

    public driversLicenseState : string = '';

    public driversLicenseExpiry : Date|undefined = undefined;

    public physicalDueDate : Date|undefined = undefined;
    
    public defaultTruckId : number|undefined = undefined;

}
